import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { FORMAT_FULL_DATE_MINI, formatDate } from 'utils/helpers/datetime';
import { getGiftVoucherTitle } from 'redux/selectors/sealink';

const GiftVoucher = ({ experience }) => {
  const { resource_id, first_travel_date } = experience;

  const name = useSelector((state) => getGiftVoucherTitle(state, resource_id));

  const formattedFirstTravelDate = formatDate(
    first_travel_date._value,
    FORMAT_FULL_DATE_MINI
  );

  return (
    <div className="text-start">
      <div className="mb-2">
        <h5>Gift voucher</h5>
      </div>

      <div className="mb-2">{name}</div>
      <div>Valid until {formattedFirstTravelDate}</div>
    </div>
  );
};

GiftVoucher.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  experience: PropTypes.object.isRequired,
};

export default GiftVoucher;
